module.exports = __webpack_public_path__ + "static/media/cara_sad_eyes_open_mouth_close.1ef7e3ca.png";